import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import { colors } from '../../../themes'
import { specialKeyPressed } from '../../../helpers/eventHelpers'
import AccessibleIcon from '../../AccessibleIcon'
import { directionMap, getCurrentDirection, getNextDirection } from '../../../helpers/tableHelpers'
import styles, { cellAlignment } from './styles'

const TableHeader = ({ sortBy, sortDirection, onSort, children }) => (
  <thead className={styles.header}>
    <tr className={styles.row}>
      {React.Children.map(children, child => {
        // Ignore any null children
        if (!child) return null

        const sortable = !!child.props.sortable && !!onSort
        const sortIcon = sortable ? directionMap[getCurrentDirection(child.props.sortable, sortBy, sortDirection)].icon : ''

        const headerProps = sortable
          ? {
              tabIndex: '0',
              onClick: () => onSort(child.props.sortable, getNextDirection(child.props.sortable, sortBy, sortDirection)),
              onKeyDown: ev => {
                if (ev.which === 13 && !specialKeyPressed(ev)) {
                  onSort(child.props.sortable, getNextDirection(child.props.sortable, sortBy, sortDirection))
                }
              },
            }
          : {}

        // If sortable, calculate the icon to show and pass onClick (make sure that there's an ID in the column for the sorting)
        // Clear any of the config props received from the children to avoid DOM warnings
        return (
          <th
            className={cx(styles.cell, cellAlignment(child.props.alignment), sortable && styles.sortable)}
            width={child.props.width}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...headerProps}>
            {React.cloneElement(child, { alignment: undefined, sortable: undefined, width: undefined })}
            {Boolean(sortable) && <AccessibleIcon icon={sortIcon} size={14} color={colors.oxfordBlue} />}
          </th>
        )
      })}
    </tr>
  </thead>
)

TableHeader.propTypes = {
  sortBy: PropTypes.string,
  sortDirection: PropTypes.string,
  onSort: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

TableHeader.defaultProps = {
  sortBy: '',
  sortDirection: '',
}

export default TableHeader
